/**
 * Per-enhet-inställningar för Sigge-add-in:et. Sparas i localStorage;
 * ingen server-synk (varje maskin/browser har sina egna prefs).
 *
 *   timerEnabled     — visar Timer-fliken + tillåter auto-start
 *   ctrlSPrompt      — Word: efter Ctrl+S öppna "logga tid"-prompt
 *   autoStartOnFocus — Word: starta timer när taskpanen laddas
 *
 * Word-specifika flaggor ignoreras tyst av Outlook-add-in:et — det
 * finns bara en settings-shape att förvalta.
 */

const KEY = "sigge_settings_v1";

/** Stage 7 — ingestion-mode-val minns per enhet, men picker:n visas
 *  varje gång och kan ändras. */
export type IngestionMode = "ingest" | "save_only" | "auto";

export interface AddinSettings {
  timerEnabled: boolean;
  ctrlSPrompt: boolean;
  autoStartOnFocus: boolean;
  /** Senast valda ingestion-mode. Default "auto". */
  lastIngestionMode: IngestionMode;
}

export const DEFAULTS: AddinSettings = {
  timerEnabled: false,
  ctrlSPrompt: false,
  autoStartOnFocus: false,
  lastIngestionMode: "auto",
};

export function loadSettings(): AddinSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<AddinSettings>;
    return { ...DEFAULTS, ...parsed };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(s: AddinSettings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* localStorage-fel — settings försämras till pure-memory
       (nästa reload får defaults). Ingen krasch. */
  }
}
